import { PhoneNumberUtil } from "google-libphonenumber";
import * as yup from "yup";
const phoneUtil = PhoneNumberUtil.getInstance();

let createPickupRequestValidationForm = yup.object().shape({
  // vehicle: yup.string().required("Vehicle is required"),
  driver: yup.string().optional().nullable(),
  sender_name: yup.string().required("Sender name is required"),
  sender_primary_contact: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
  receiver_primary_contact: yup
    .string()
    .optional()
    .nullable()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return true; // empty is OK
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    }),
  sender_address: yup.string().required("Sender Address is required"),
});
let vehicleValidationForm = yup.object().shape({
  emergency_contact_number: yup
    .string()
    .required("Emergency Contact is required")
    .transform(function (value) {
      if (value && !value.startsWith("+977")) {
        return "+977" + value;
      }
      return value;
    }),
  license_number: yup.string().required("License Number is required"),
});
let createRiderValidationForm = yup.object().shape({
  username: yup.string().required("Username is required"),
  full_name: yup.string().required("Full Name is required"),
  email: yup.string().email().required("Email is required"),
  mobile_number: yup
    .string()
    .required("Mobile Number is required")
    .transform(function (value) {
      if (value && !value.startsWith("+977")) {
        return "+977" + value;
      }
      return value;
    }),
  license_number: yup.string().required("License Number is required"),
  citizenship_number: yup.string().required("Citizenship Number is required"),
});
let createPickupNoteValidationForm = yup.object().shape({
  // sender_name: yup.string().required("Sender name is required"),
  sender_primary_contact: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
  receiver_primary_contact: yup
    .string()
    .optional()
    .nullable()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return true; // empty is OK
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    }),
  sender_address: yup.string().required("Sender Address is required"),
});
let orderRemarksValidationForm = yup.object().shape({
  comment: yup.string().required("Remark is required"),
});
const emailDownloadValidationForm = yup.object().shape({
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  date_range: yup.string().required("Date range is required"),
});
const deliveryformValidation = yup.object().shape({
  full_name: yup.string().required("Full Name is required"),
  primary_contact: yup
    .string()
    .required("Phone Number is required")
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value || value.trim() === "") return true;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch {
        return false;
      }
    }),
  signature: yup
    .mixed<File>()
    .required("Signature is required")
    .test("file-exists", "Signature is required", (value) => {
      return value instanceof File;
    }),
});
export {
  createPickupRequestValidationForm,
  vehicleValidationForm,
  createRiderValidationForm,
  createPickupNoteValidationForm,
  orderRemarksValidationForm,
  emailDownloadValidationForm,
  deliveryformValidation
};

